import {Injectable} from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import {catchError, retryWhen} from 'rxjs/operators';
import {Subject, Observable, interval, of} from 'rxjs';
import {environment} from '../../../../../environments/environment';
import { ThrobberService } from 'src/app/_services/throbber.service';
import { Unidad } from 'src/app/_models/unidad';
import { version } from 'punycode';

const API_URL = environment.apiUrl;

@Injectable({
  providedIn: 'root'
})
export class UnidadEtapasService {
  private subject = new Subject<any>();

  materiasPeriodo: any = [];

  constructor(private http: HttpClient,
    private throbberService: ThrobberService) {

  }

  conectarConUnidad(tipo, idUnidad, idObjeto) {
    const body = {
      'idOrigen': idUnidad,
      'idDestino': idObjeto,
      'isConectada': true
    };
    return this.http.post<HttpResponse<any>>(`${API_URL}/api/unidades/${tipo}/conectar`, body, {});
  }

  conectarMetas(objeto) {
    return this.http.post<HttpResponse<any>>(`${API_URL}/api/unidades/metaU/conectar`, objeto, {});
  }

  quitarDeUnidad(tipo, idUnidad, idObjeto) {
    const body = {
      'idOrigen': idUnidad,
      'idDestino': idObjeto,
      'isConectada': false
    };
    return this.http.post<HttpResponse<any>>(`${API_URL}/api/unidades/${tipo}/conectar`, body, {});
  }

  ordenarMetas(ids) {
    const model = {ids: ids};
    return this.http.put<HttpResponse<any>>(`${API_URL}/api/Unidades/meta/ordenar`, model, {});
  }

  ordenarCriterios(ids) {
    const model = {ids};
    return this.http.put<HttpResponse<any>>(`${API_URL}/api/Criterios/ordenar`, model, {});
  }

  getCriteriosMeta(id) {

  }

  setMetaRP(model) {
    return this.http.put<HttpResponse<any>>(`${API_URL}/api/Unidades/meta/RP`, model, {});
  }

  setMaterias(materias) {
    this.materiasPeriodo = materias;
    this.subject.next({tipo: 'actualizar-materias-periodo', materias});
  }

  getMaterias() {
    return this.materiasPeriodo;
  }

  setEstadoMCP(idOrigen, estado) {
    const model = {idOrigen, estado};
    return this.http.put<HttpResponse<any>>(`${API_URL}/api/Unidades/eventomateria/estado`, model, {});
  }

  guardarMCP(model) {
    return this.http.put<HttpResponse<any>>(`${API_URL}/api/Unidades/eventomateria/fechaduracion`, model, {});
  }

  eliminarEventoMateria(id) {
    return this.http.delete<HttpResponse<any>>(`${API_URL}/api/Unidades/eventomateria/borrar/${id}`, {});
  }

  eliminarRecurso(id) {
    return this.http.delete<HttpResponse<any>>(`${API_URL}/api/Recursos/Borrar/${id}`, {});
  }

  actualizarRecurso(recurso) {
    return this.http.put<HttpResponse<any>>(`${API_URL}/api/Recursos/actualizar`, recurso, {});
  }

  actualizarObjeto(tipo, objeto) {
    this.subject.next({tipo: `actualizar-${tipo}`, objeto});
  }

  actualizarListaEventos(eventoUnidad) {
    this.subject.next({tipo: 'actualizar-lista-eventos', eventoUnidad});
  }

  actualizarLista(tipo, objetoUnidad) {
    this.subject.next({tipo: `actualizar-lista-${tipo}`, objetoUnidad});
  }

  eliminarObjeto(tipo, objeto) {
    this.subject.next({tipo: `eliminar-${tipo}`, objeto});
  }

  agregarObjeto(tipo, objeto) {
    this.subject.next({tipo: `agregar-${tipo}`, objeto});
  }

  actualizarCalendario(evento) {
    this.subject.next({tipo: 'actualizar-calendario-eventos', evento});
  }

  emitAbrirModal(objetoId, tipoObjeto, callback?) {
    let url = `${API_URL}`;
    if (tipoObjeto == 'meta') {
      url += `/api/Metas/${objetoId}`;
    } else if (tipoObjeto == 'meta_unidad' || tipoObjeto == 'comentarios_meta' || tipoObjeto == 'criterios_meta') {
      url += `/api/Metas/${objetoId.id}/version/${objetoId.versionId}/criterios`;
    } else if (tipoObjeto == 'unidad') {
      url += `/api/Unidades/${objetoId}`;
    } else if (tipoObjeto == 'evento') {
      url += `/api/EventosAprendizaje/${objetoId}`;
    } else if (tipoObjeto == 'evento-unidad' || tipoObjeto == 'comentarios_evento') {
      url += `/api/Unidades/evento/${objetoId}`;
    } else if (tipoObjeto == 'lista-metas-conectar') {
      url += `/api/Unidades/evento/${objetoId}/metas`;
    } else if (tipoObjeto == 'comentarios_unidad') {
      url += `/api/Comentarios/${objetoId}/unidad`;
    }
    this.throbberService.setThrobberState(true);
    this.http.get<HttpResponse<any[]>>(url).subscribe(objectResp => {
      this.throbberService.setThrobberState(false);
      this.subject.next({tipo: 'abrir-modal', objeto: objectResp, tipoObjeto: tipoObjeto, objetoId});
      if (typeof callback == 'function') {
        callback();
      }
    });
  }

  emitAbrirDialogo(objetoId, tipoObjeto) {
    let url = `${API_URL}`;
    if (tipoObjeto == 'rubrica_meta') {
      url += `/api/Unidades/meta/${objetoId}/rubrica`;
    } else if (tipoObjeto == 'rubrica_evento') {
      url += `/api/Unidades/evento/${objetoId}/rubrica`;
    } else if (tipoObjeto == 'rubrica_unidad') {
      url += `/api/Unidades/${objetoId}/rubrica`;
    } else if (tipoObjeto == 'evento-unidad-detalle') {
      url += `/api/Unidades/evento/${objetoId}`;
    }
    this.throbberService.setThrobberState(true);
    this.http.get<HttpResponse<any[]>>(url).subscribe(objectResp => {
      this.throbberService.setThrobberState(false);
      this.subject.next({tipo: 'abrir-dialogo', objeto: objectResp, tipoObjeto: tipoObjeto, objetoId});
    });
  }

  getRubricaEvento(eventoId): Observable<any> {
    return this.http.get<any[]>(`${API_URL}/api/Unidades/evento/${eventoId}/rubrica`);
  }

  getRubricaUnidad(id) {
    return this.http.get<HttpResponse<any[]>>(`${API_URL}/api/Unidades/${id}/rubrica`);
    /*.pipe(retryWhen((err) => {
      return interval(5000);
    }));*/
  }

  getUnidadEtapasObservable(): Observable<any> {
    return this.subject.asObservable();
  }

  setLanguage(idioma: string, unidad: Unidad, personaId: number) {
    const model = {
      unidadId: unidad.id,
      personaId: personaId,
      idioma: idioma
    };
    return this.http.post<any>(`${API_URL}/api/Unidades/idioma`, model);
  }
}
